import { defineMessages } from 'react-intl';

const messages = defineMessages({
  stepTitle: {
    id: 'registration.businessInformation.stepTitle',
    defaultMessage: 'Business information',
    description: 'Registration personal details step title',
  },
  title: {
    id: 'registration.businessInformation.title',
    defaultMessage: 'Business information',
    description: 'Registration personal details title',
  },
  description: {
    id: 'registration.businessInformation.description',
    defaultMessage: 'Please enter your Business name and Business address.',
    description: 'Registration personal details description',
  },
  addressSearch: {
    id: 'registration.businessInformation.addressSearch',
    defaultMessage: 'Address search',
    description: 'Registration business information address search',
  },
  addressSearchHint: {
    id: 'registration.businessInformation.addressSearchHint',
    defaultMessage: 'Start typing your city, postal code, or street name to find your address.',
    description: 'Registration business information address search hint',
  },
  addressSearchNoResults: {
    id: 'registration.businessInformation.addressSearchNoResults',
    defaultMessage: 'No results found. Please enter a valid address or enter your address manually.',
    description: 'Registration business information address search no results',
  },
  addressSearchApiError: {
    id: 'registration.businessInformation.addressSearchManual',
    defaultMessage: 'Unable to load suggestions. Please enter your address manually.',
    description: 'Registration business information address search api error',
  },
});

export default messages;
